export default __webpack_public_path__ + "static/media/dex4t2e.001987d6.png";